import { Flex, PrimarySecondaryPage, WorkflowPage } from "@wayflyer/flyui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import {
  CashFlowForecastDocumentUpload,
  DocumentNavigationGroup,
  useDocumentNavigationActions,
  MESSAGES,
} from "../components";

export const CashFlowForecastDocumentUploadPage = () => {
  const intl = useIntl();
  const isNewOnboardingFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.CASH_FLOW_FORECAST
  ).length;

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.CASH_FLOW_FORECAST,
  });

  if (isNewOnboardingFlowEnabled) {
    return (
      <WorkflowPage
        variant="wide"
        titleSlot={<OnboardingStepper currentStep={4} />}
        title={intl.formatMessage(MESSAGES.revenueProjectionsTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <CashFlowForecastDocumentUpload />
        </Flex>
      </WorkflowPage>
    );
  }

  const CashFlowForecastDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <CashFlowForecastDocumentUpload />
      <DocumentNavigationGroup
        isStepComplete={hasUploadedDocuments || fundingApplicationData.isCashflowForecastSkipped === true}
        forType={UploadDocumentType.CASH_FLOW_FORECAST}
      />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={intl.formatMessage(MESSAGES.revenueProjectionsTitle)}
      primaryContent={CashFlowForecastDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
